import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import { AppState } from 'store/store';

import './style.css';
import { useExamCenter } from 'hooks';

export type ExamCenterFilterType = {
  title: string;
  examCentreId: string | undefined;
};

type FilterProps = {
  onSetFilter: (filter: any) => void;
};

const ExamCenterFilter: React.FC<FilterProps> = ({ onSetFilter }) => {
  const defaultFilter = {
    title: 'All exam centres',
    examCentreId: undefined,
  };
  const loggedUser = useSelector((state: AppState) => state.session.userInfo);
  const [examCentreFilter, setExamCentreFilter] = useState<
    ExamCenterFilterType | undefined
  >(defaultFilter);
  const [examCentreFilterValues, setExamCentreFilterValues] = useState<
    ExamCenterFilterType[]
  >([]);
  const { examCenters } = useExamCenter();

  useEffect(() => {
    if (examCenters?.centers.length) {
      const filterValues = examCenters?.centers.map((centre: any) => {
        return {
          title: `(${centre.code}) ${centre.name}`,
          examCentreId: centre._id,
        };
      });
      setExamCentreFilterValues(filterValues);
    }
  }, [examCenters]);

  const setFilter = useCallback(
    (filter: ExamCenterFilterType | undefined) => {
      setExamCentreFilter(filter);
      if (filter?.examCentreId) {
        onSetFilter({
          examCentreId: filter?.examCentreId,
        });
      } else {
        onSetFilter({});
      }
    },
    [onSetFilter],
  );

  const dropdownItems = useMemo(() => {
    return Object.keys(examCentreFilterValues).map((f, index) => {
      const filter = examCentreFilterValues[f];
      return (
        <DropdownItem key={index} onClick={() => setFilter(filter)}>
          {filter.title}
        </DropdownItem>
      );
    });
  }, [examCentreFilterValues]);

  return (
    <>
      <UncontrolledDropdown className={`filter-button_exam`}>
        <DropdownToggle caret>{examCentreFilter?.title}</DropdownToggle>
        <DropdownMenu className="filter-dropdown_scrollable">
          <DropdownItem onClick={() => setFilter(defaultFilter)}>
            {defaultFilter.title}
          </DropdownItem>
          {dropdownItems}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

export default ExamCenterFilter;
